// Vendor libraries
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
/**
 *
 * NgModel Change Debounced Directive
 *
 * In AngularJS, we could easily use ng-model-options to pass in a debounce time (i.e. how long to wait after the user
 * stops typing to process their input). Unfortunately this feature no longer exists in Angular 9+ so we are creating
 * our own directive that handles this for us.
 *
 * If you need to add a debounce time to NgModelChange, use this directive instead.
 *
 * Input Properties:
 *  debounceTime: How long to debounce for in ms (optional)
 *
 * Output Properties:
 *  debouncedChangeHandler: The handler to call after the NgModel has changed
 *
 */
export class NgModelChangeDebouncedDirective {
    constructor(ngModel) {
        this.ngModel = ngModel;
        this.debounceTime = 500;
        this.debouncedChangeHandler = new EventEmitter();
        this.subscription = this.ngModel.control.valueChanges
            .pipe(skip(1), // skip initial value (when the NgModel is first initialized with an empty value)
        distinctUntilChanged(), debounceTime(this.debounceTime))
            .subscribe(() => {
            // In our only current use case (invite-friend-modal.template.html), we do need to use the value from
            // the subscription. However if necessary we could easily emit the value.
            this.debouncedChangeHandler.emit();
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
NgModelChangeDebouncedDirective.ɵfac = function NgModelChangeDebouncedDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NgModelChangeDebouncedDirective)(i0.ɵɵdirectiveInject(i1.NgModel)); };
NgModelChangeDebouncedDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: NgModelChangeDebouncedDirective, selectors: [["", "ycnNgModelChangeDebounced", ""]], inputs: { debounceTime: "debounceTime" }, outputs: { debouncedChangeHandler: "debouncedChangeHandler" }, standalone: false });
